import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import PointInquiry from '../views/PointInquiry.vue';
import CustomerInquiry from '../views/CustomerInquiry.vue';
import CustomerInquiry2 from '../views/CustomerInquiry2.vue';
import ApiConsole from '../views/ApiConsole.vue';
import ManualPurchase from '../views/ManualPurchase.vue';
import BatchResult from '../views/BatchResult.vue';
import PaymentHistory from '../views/PaymentHistory.vue';
import PaymentInquiry2 from '../views/PaymentInquiry2.vue';
import CenterAdmin from '../views/CenterAdmin.vue';
import BranchAdmin from '../views/BranchAdmin.vue';
import ComCodeView from '../views/ComCodeView.vue';
import SmsTempSendView from '../views/SmsTempSendView.vue';
import SmsHistView from '../views/SmsHistView.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'login', component: Login },
  { path: '/point', name: 'point', component: PointInquiry, meta: { auth: true } },
  { path: '/customer', name: 'customer', component: CustomerInquiry, meta: { auth: true } },
  // 스펙234_개선_13: 고객 조회(상단 고객정보 + 하단 고객정보 수신 임시목록). staff/admin 용 결합화면
  { path: '/customer2', name: 'CustomerInquiry2', component: CustomerInquiry2, meta: { auth: true, admin: true } },
  { path: '/payment-history', name: 'PaymentHistory', component: PaymentHistory, meta: { auth: true } },
  // 스펙46: API 조회·배치 결과는 role=admin 전용
  { path: '/api-console', name: 'ApiConsole', component: ApiConsole, meta: { auth: true, adminOnly: true } },
  { path: '/batch-result', name: 'BatchResult', component: BatchResult, meta: { auth: true, adminOnly: true } },
  { path: '/manual-purchase', name: 'ManualPurchase', component: ManualPurchase, meta: { auth: true, adminOnly: true } },
  // 스펙54: 결제내역 조회 화면2 (상단 결제내역 조회 + 하단 수동저장 목록). 하단은 staff 만 선명/사용.
  { path: '/payment2', name: 'PaymentInquiry2', component: PaymentInquiry2, meta: { auth: true, admin: true } },
  // 20003: 센터 조회는 staff/admin. 20009: 지사 조회/공통코드는 admin 전용
  { path: '/center-admin', name: 'CenterAdmin', component: CenterAdmin, meta: { auth: true, admin: true } },
  { path: '/branch-admin', name: 'BranchAdmin', component: BranchAdmin, meta: { auth: true, adminOnly: true } },
  { path: '/com-code', name: 'ComCodeView', component: ComCodeView, meta: { auth: true, adminOnly: true } },
  // 28002: 관리자 메뉴 - SMS 발송(수동) / SMS 발송 이력 조회 (admin 전용)
  { path: '/sms-temp-send', name: 'SmsTempSendView', component: SmsTempSendView, meta: { auth: true, adminOnly: true } },
  { path: '/sms-hist-view', name: 'SmsHistView', component: SmsHistView, meta: { auth: true, adminOnly: true } }
];

const router = new VueRouter({ mode: 'hash', routes });

// 간단 인증 가드 (데모: 세션스토리지 미사용, 메모리 로그인 상태)
// 일반 회원은 customerId, 운영자(cafe24)는 loginId 로 로그인 상태 판단
router.beforeEach((to, from, next) => {
  const auth = window.__AUTH__;
  const loggedIn = !!(auth && (auth.customerId || auth.loginId));
  if (to.meta && to.meta.auth && !loggedIn) next('/login');
  else if (to.meta && to.meta.adminOnly && !(auth && auth.role === 'admin')) next('/point');
  else if (to.meta && to.meta.admin && !(auth && (auth.role === 'admin' || auth.role === 'staff'))) next('/point');
  else next();
});

export default router;
